import _import_ from "@assets/js/pub_import.js";
const BASE_URL = "masterData";
export default [
    {
        path: "/blankHome",
        component: _import_(BASE_URL + "/blankHome.vue")
    },
    {
        path: "/shipmentOrder",
        component: _import_(BASE_URL + "/newSopage/so.vue")
    },
    {
        path: "/proj_ge",
        component: _import_(BASE_URL + "/proGeneric.vue")
    },
    {
        path: "/sku",
        component: _import_(BASE_URL + "/skuPage.vue"),
    },
    {
        path: "/whs",
        component: _import_(BASE_URL + "/Warehouse.vue"),
    },
    {
        path: "/loa",
        component: _import_(BASE_URL + "/loaction.vue"),
    },
    {
        path: "/ogr",
        component: _import_(BASE_URL + "/customer.vue"),
    },
    {
        path: "/project",
        component: _import_(BASE_URL + "/project.vue"),
    },
    {
        path: "/partner",
        component: _import_(BASE_URL + "/partner.vue"),
    },
    {
        path: "/sysparam",
        component: _import_(BASE_URL + "/sysparam.vue"),
    },
    {
        path: "/mult",
        component: _import_(BASE_URL + "/multilingual.vue"),
    },
    {
        path: "/codeMaster",
        component: _import_(BASE_URL + "/codeMaster.vue"),
    },
    {
        path: "/menu",
        component: _import_(BASE_URL + "/menu.vue"),
    },
    {
        path: "/sysModule",
        component: _import_(BASE_URL + "/sysModule.vue"),
    },
    {
        path: "/idGener",
        component: _import_(BASE_URL + "/idGener.vue"),
    },
    {
        path: "/invCode",
        component: _import_(BASE_URL + "/invCode.vue"),
    },
    {
        path: "/rfUser",
        component: _import_(BASE_URL + "/rfUser.vue"),
    },
    {
        path: "/po",
        component: _import_(BASE_URL + "/po.vue"),
    },
    {
        path: "/asnStatic",
        component: _import_(BASE_URL + "/staticPage.vue"),
    },
    {
        path: "/support",
        component: _import_(BASE_URL + "/support.vue"),
    },
    {
        path: "/billingMaintance",
        component: _import_(BASE_URL + "/billingMaintance.vue"),
    },
    {
        path: "/job",
        component: _import_(BASE_URL + "/job.vue"),
    },
    {
        path: "/timer",
        component: _import_(BASE_URL + "/timer.vue"),
    },
    {
        path: "/asn",
        component: _import_(BASE_URL + "/asn.vue"),
    },
    {
        path: "/inbGr",
        component: _import_(BASE_URL + "/inbGr.vue"),
    },
    {
        path: "/receive",
        component: _import_(BASE_URL + "/receive.vue"),
    },
    {
        path: "/putaway",
        component: _import_(BASE_URL + "/putaway.vue"),
    },
    {
        path: "/pso",
        component: _import_(BASE_URL + "/pso.vue"),
    },
    {
        path: "/so",
        component: _import_(BASE_URL + "/so.vue"),
    },
    {
        path: "/wave",
        component: _import_(BASE_URL + "/wave.vue"),
        // component: _import_(BASE_URL + "/skuIE.vue"),
    },
    {
        path: "/pick",
        component: _import_(BASE_URL + "/pick.vue"),
    },
    {
        path: "/ediLogSummary",
        component: _import_(BASE_URL + "/ediLogSummary.vue"),
    },
    {
        path: "/pack",
        component: _import_(BASE_URL + "/pack.vue"),
    },
    {
        path: "/cmg",
        component: _import_(BASE_URL + "/cartonManagement.vue"),
    },
    {
        path: "/balance",
        component: _import_(BASE_URL + "/balance.vue"),
    },
    {
        path: "/transaction",
        component: _import_(BASE_URL + "/transaction.vue"),
    },
    {
        path: "/transactionNew",
        component: _import_(BASE_URL + "/transactionNew.vue"),
    },
    {
        path: "/enquiryLot",
        component: _import_(BASE_URL + "/enquiryLot.vue"),
    },
    {
        path: "/enquiryUser",
        component: _import_(BASE_URL + "/enquiryUser.vue"),
    },
    {
        path: "/enquirySku",
        component: _import_(BASE_URL + "/enquirySku.vue"),
    },
    {
        path: "/enquiryLoc",
        component: _import_(BASE_URL + "/enquiryLoc.vue"),
    },
    {
        path: "/lnvnMove",
        component: _import_(BASE_URL + "/lnvnMove.vue"),
    },
    {
        path: "/invAdjust",
        component: _import_(BASE_URL + "/invAdjust.vue"),
    },
    {
        path: "/invTransfer",
        component: _import_(BASE_URL + "/invTransfer.vue"),
    },
    {
        path: "/invHold",
        component: _import_(BASE_URL + "/invHold.vue"),
    },
    {
        path: "/skuHeader",
        component: _import_(BASE_URL + "/skuHeader.vue"),
    },
    {
        path: "/userReport",
        component: _import_(BASE_URL + "/userReport.vue"),
    },
    // {
    //     path: "/report",
    //     component: _import_(BASE_URL + "/report.vue"),
    // },
    {
        path: "/userGeneric",
        component: _import_(BASE_URL + "/report.vue")
    },
    {
        path: "/importConfig",
        component: _import_(BASE_URL + "/importConfigMaster.vue")
    },
    {
        path: "/noneEditable",
        component: _import_(BASE_URL + "/noneEditable.vue")
    },
    {
        path: "/stdBalanceReport",
        component: _import_(BASE_URL + "/userReport/stdBalanceReport.vue")
    },
    {
        path: "/deliveryOrderSum",
        component: _import_(BASE_URL + "/userReport/deliveryOrderSum.vue")
    },
    {
        path: "/consignment",
        component: _import_(BASE_URL + "/consignment.vue")
    },
    {
        path: "/pallet",
        component: _import_(BASE_URL + "/pallet.vue")
    },
    {
        path: "/shipment",
        component: _import_(BASE_URL + "/shipment.vue")
    },
    {
        path: "/cycleCount",
        component: _import_(BASE_URL + "/cycleCount.vue")
    },
    {
        path: "/cycleCountMaster",
        component: _import_(BASE_URL + "/cycleCountMaster.vue")
    },
    {
        path: "/scanToPrintWindow",
        component: _import_(BASE_URL + "/scanToPrintWindow.vue")
    },
    {
        path: "/nonWorkdayMaster",
        component: _import_(BASE_URL + "/nonWorkdayMaster.vue")
    },
    {
        path: "/approvalPathMaster",
        component: _import_(BASE_URL + "/approvalPathMaster.vue")
    },
    {
        path: "/printPriceTag",
        component: _import_(BASE_URL + "/printPriceTag.vue")
    }
];
